import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Filters from '../components/Filters'
import OEFilterButton from '../components/OEFilterButton'

const TireSearchGuidedNavigation = ({
  className,
  title,
  navigation = [],
  totalNumRecs,
  filterItems,
  resetFilters,
  selectedFilters = []
}) =>
  <Media.Desktop>
    <FiltersWrapper>
      <CustomOeFilterButton />
      <Filters
        totalNumRecs={ totalNumRecs }
        title={ title }
        navigation={ navigation }
        filterItems={ filterItems }
        resetFilters={ resetFilters }
        selectedFilters={ selectedFilters } />
    </FiltersWrapper>
  </Media.Desktop>

export default TireSearchGuidedNavigation

TireSearchGuidedNavigation.propTypes = {
  className: PropTypes.string,
  filterItems: PropTypes.func,
  navigation: PropTypes.arrayOf(PropTypes.shape()),
  resetFilters: PropTypes.func,
  selectedFilters: PropTypes.arrayOf(PropTypes.shape()),
  title: PropTypes.string,
  totalNumRecs: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
}

const FiltersWrapper = styled.div`
  display: table-cell;
  width: 228px;
  min-width: 228px;
  max-width: 228px;
  vertical-align: top;
`

const CustomOeFilterButton = styled(OEFilterButton)`
  margin-bottom: 38px;
  margin-top: 4px;
`

